// import { createSelector } from 'reselect'

const getTokenSelector = state => state.user.token

export {
  getTokenSelector
}